export const SCREEN_XS = 480;
export const SCREEN_SM = 768;
export const SCREEN_MD = 992;
export const SCREEN_LG = 1200;

export const SCREEN_XXXS_MIN = 320;
export const SCREEN_XXS_MIN = 480;
export const SCREEN_XS_MIN = 574;
export const SCREEN_SM_MIN = 768;
export const SCREEN_MD_MIN = 992;
export const SCREEN_LG_MIN = 1200;

export const SCREEN_XXS_MAX = SCREEN_XS_MIN - 1;
export const SCREEN_XS_MAX = SCREEN_SM_MIN - 1;
export const SCREEN_SM_MAX = SCREEN_MD_MIN - 1;
export const SCREEN_MD_MAX = SCREEN_LG_MIN - 1;
